import { useEffect, useState } from 'react'
import { settingsApi, type AppSetting } from '../crmApi'
import { apiErrorMessage } from '../api'

export function Settings() {
  const [items, setItems] = useState<AppSetting[]>([])
  const [draft, setDraft] = useState<Record<string, string>>({})
  const [error, setError] = useState<string | null>(null)
  const [saved, setSaved] = useState<string | null>(null)

  useEffect(() => {
    settingsApi.list()
      .then((s) => { setItems(s); setDraft(Object.fromEntries(s.map((x) => [x.key, x.value]))) })
      .catch((e) => setError(describe(e)))
  }, [])

  async function save(key: string) {
    try {
      await settingsApi.update(key, draft[key])
      setSaved(key); setError(null); setTimeout(() => setSaved(null), 1500)
    } catch (e) { setError(describe(e)) }
  }

  return (
    <div>
      <h1>Applikationsvariabler</h1>
      <p className="muted">Administreras av administratör. Styr fakturering (avgift, förfallotider, minsta belopp).</p>
      {error && <p className="error">{error}</p>}

      <table className="grid">
        <thead><tr><th>Nyckel</th><th>Beskrivning</th><th>Värde</th><th></th></tr></thead>
        <tbody>
          {items.map((s) => (
            <tr key={s.key}>
              <td><code>{s.key}</code></td>
              <td className="muted">{s.description}</td>
              <td><input value={draft[s.key] ?? ''} onChange={(e) => setDraft({ ...draft, [s.key]: e.target.value })} style={{ width: '8rem' }} /></td>
              <td className="actions">
                <button className="primary" onClick={() => void save(s.key)}>Spara</button>
                {saved === s.key && <span className="badge" style={{ marginLeft: '0.5rem' }}>Sparat</span>}
              </td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan={4} className="muted">Inga variabler (kräver administratörsroll).</td></tr>}
        </tbody>
      </table>
    </div>
  )
}

const describe = apiErrorMessage
